import getBulkDiscount from './getBulkDiscount';
import { getBulkDiscountsForTicketType } from './getBulkDiscountsForTicketType';

export default function getTotalTicketTypesAmount(ticketTypes, ticketTypeDiscounts) {
  if (!ticketTypes || !ticketTypes.length) {
    return { totalTicketTypesAmount: 0, totalTicketTypesDiscountAmount: 0 };
  }

  return ticketTypes.reduce(
    (acc, ticketType) => {
      // Ensure price and quantity are numbers
      const price = Number(ticketType.price) || 0;
      const quantity = Number(ticketType.quantity) || 0;

      const bulkDiscountsToApply = getBulkDiscountsForTicketType(
        ticketTypeDiscounts,
        ticketType._id,
      );

      const ticketAmount = price * quantity;
      const { bulkDiscountAmount } = getBulkDiscount(bulkDiscountsToApply, quantity, ticketAmount);

      const discountAmount = Number(bulkDiscountAmount) || 0;

      return {
        totalTicketTypesAmount: acc.totalTicketTypesAmount + ticketAmount,
        totalTicketTypesDiscountAmount: acc.totalTicketTypesDiscountAmount + discountAmount,
      };
    },
    { totalTicketTypesAmount: 0, totalTicketTypesDiscountAmount: 0 },
  );
}
